// Agents on the web (the web's; Project ▸ Agents on the Web…): which assistants may read this project.
export { AgentsPage as component } from '../../views/AgentsPage.tsx';
export const room = 'library';
export const page = 'agents';
export const title = 'Agents on the web';
export const help = 'assistants';
export const hidden = true;
